module.exports = __webpack_public_path__ + "bae28a45accc6ab524260f5bc445102c.mp4";